import { FC, PropsWithChildren, useEffect } from 'react';
import { createPortal } from 'react-dom';
import isEmpty from 'lodash/isEmpty';

import { CloseIcon, IIconProps } from '../icons/icons';

interface IModalProps extends PropsWithChildren {
	title: string;
	btnSubmitTxt?: string;
	closeModal: () => void;
	additionalModalClass?: string;
	isSubmitDisabled?: boolean;
	isFooter?: boolean;
	className?: string;
	subTitle?: string;
	btnCancelTxt?: string;
	isShowCloseIcon?: boolean;
	TitleIcon?: FC<IIconProps>;
	onSubmit?: () => void;
	onClose?: () => void;
}
const Modal: FC<IModalProps> = ({
	title,
	subTitle,
	className,
	additionalModalClass,
	children,
	isSubmitDisabled = false,
	btnSubmitTxt = 'Submit',
	btnCancelTxt = 'Cancel',
	isFooter = true,
	isShowCloseIcon = true,
	TitleIcon,
	closeModal,
	onClose,
	onSubmit
}) => {
	useEffect(() => {
		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = 'unset';
		};
	}, []);

	return createPortal(
		<div className={`modal-wrapper ${additionalModalClass}`} onClick={closeModal}>
			<div className={`${className} modal-content`} onClick={(e) => e.stopPropagation()}>
				{isShowCloseIcon && (
					<button className='close-button no--bg position--absolute' onClick={closeModal}>
						<CloseIcon />
					</button>
				)}

				<div className='heading-wrapper'>
					<h3 className='no--margin text--gray font-size--lg'>
						<div className='modal-title-wrapper flex align-items--center'>
							{TitleIcon && <TitleIcon className='mr--10 ml--16' />}
							<p title={title} className='modal-title font-size--lg font--bold'>
								{title}
							</p>
						</div>
						{!isEmpty(subTitle) && <p className='title mt--25 mb--15 ml--12'>{subTitle}</p>}
					</h3>
				</div>
				<div className='body-wrapper'>{children}</div>

				{isFooter && (
					<div className='footer-wrapper text--center'>
						{isShowCloseIcon && (
							<button className='button cancel-btn no--bg mr--20 text--white' onClick={onClose}>
								{btnCancelTxt}
							</button>
						)}
						{btnSubmitTxt && (
							<button
								type='submit'
								className='button bg--primary text--white'
								onClick={onSubmit}
								disabled={isSubmitDisabled}
							>
								{btnSubmitTxt}
							</button>
						)}
					</div>
				)}
			</div>
		</div>,
		document.body
	);
};

export default Modal;
